export function mapLayoutToOrder(layout: string): 'regular' | 'reverse' {
  return layout === 'par défaut' ? 'regular' : 'reverse';
}

/** Strapi `layout` (ex. text-media) → prop / `data-layout` de `WaveWrapper`. */
export function mapStrapiLayoutToWaveWrapper(layout: string): 'default' | 'reverse' {
  return layout === 'par défaut' ? 'default' : 'reverse';
}
